import { render, staticRenderFns } from "./newpv.vue?vue&type=template&id=b4e2e9da&scoped=true&"
import script from "./newpv.vue?vue&type=script&lang=js&"
export * from "./newpv.vue?vue&type=script&lang=js&"
import style0 from "./newpv.vue?vue&type=style&index=0&id=b4e2e9da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4e2e9da",
  null
  
)

export default component.exports